import { render, staticRenderFns } from "./RoomScheduling.vue?vue&type=template&id=036296f8&scoped=true&"
import script from "./RoomScheduling.vue?vue&type=script&lang=js&"
export * from "./RoomScheduling.vue?vue&type=script&lang=js&"
import style0 from "./RoomScheduling.vue?vue&type=style&index=0&id=036296f8&lang=scss&scoped=true&"
import style1 from "./RoomScheduling.vue?vue&type=style&index=1&id=036296f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036296f8",
  null
  
)

export default component.exports